<template>
  <v-row no-gutters >
    <v-col class="px-6 py-4" cols="12">
      <h3 class="mt-0 text-h3">{{ $t('ppi-text-1') }}</h3>
      <p mt-0>{{ $t('ppi-text-2') }}</p>
    </v-col>
    <v-col cols="12">
      <v-tabs v-model="tab" slider-color="color-new-link-blue" class="ok-tabs debt-info-subtabs" @change="tabPageEvent">
        <v-tab href="#tab-debt-rows" class="text-subtitle-1 color-new-link-blue--text">
          {{ $t('debtDetails') }}
        </v-tab>
        <v-tab href="#tab-payment-plan" class="text-subtitle-1 color-new-link-blue--text">
          {{ $t('paymentPlan') }}
        </v-tab>
        <v-tab href="#tab-payments" class="text-subtitle-1 color-new-link-blue--text">
          {{ $t('payments') }}
        </v-tab>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="tab-debt-rows">
            <v-row no-gutters >
              <v-col cols="12">
                <v-card-text>
                  <debt-rows :debts="paymentPlan.debts"></debt-rows>
                </v-card-text>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item value="tab-payment-plan">
            <payment-plan :paymentPlan="paymentPlan"></payment-plan>
          </v-tab-item>
          <v-tab-item value="tab-payments">
            <payment-plan-payments :payments="paymentPlan.payments"></payment-plan-payments>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-col>
  </v-row>
</template>

<script>
  import DebtRows from './DebtRows.vue'
  import Payments from './Payments.vue'
  import PaymentPlan from './PaymentPlan.vue'

  export default {
    data: function () {
      return {
        paymentData: {},
        customPaymentDialog: false,
        transferDueDateDialog: false,
        showPaymentPlan: false,
        tab: null
      }
    },
    props: ['paymentPlan'],
    computed: {
      hasActivePaymentPlan () {
        return this.debt.paymentPlan !== null
      }
    },
    components: {
      'debt-rows': DebtRows,
      'payment-plan-payments': Payments,
      'payment-plan': PaymentPlan
    }
  }
</script>

<style>
  .debt-info-subtabs .v-tabs__container::after {
    background-color: lightgrey;
    height: 4px;
    position: absolute;
    bottom: 0;
    width: 100%;
    content: ' ';
  }

  .debt-info-subtabs .v-tabs__slider-wrapper {
    z-index: 2;
  }

  .debt-info-subtabs .v-tabs__slider {
    height: 4px;
  }
</style>

<i18n>
  {
  "fi": {
  "ppi-text-1": "Suunnitelman tiedot",
  "ppi-text-2": "Tarkastele maksusuunnitelman tarkempia tietoja"
  },
  "se": {
  "ppi-text-1": "Betalningsplanens information",
  "ppi-text-2": "Här kan du kontrollera betalningsplanens detaljuppgifter"
  },
  "en": {
  "ppi-text-1": "Payment plan information",
  "ppi-text-2": "Here you can check the detailed information of the payment plan"
  }
  }
</i18n>
